import './scripts/slick';
import $ from 'jquery';
import MobileMenu from './scripts/MobileMenu';
import StickyHeader from './scripts/StickyHeader';
import RevealOnScroll from './scripts/Reveal';
import Map from './scripts/Map';
import CookieComp from './scripts/CookieComp';
//import LastOddMenu from './scripts/LastOddMenu';

const mobileMenu = new MobileMenu();
new RevealOnScroll($('.testimonial'), '75%');
new RevealOnScroll($('.introduction-img'), '75%');
new StickyHeader();
//const stickyHeader = new StickyHeader();

new Map(20.5865900, 48.1151000, 15);
const cookie = new CookieComp('vendegloapisztrangoshoz-cookie-comp');

//new LastOddMenu('.menu-sheet--items-container--item');

$(document).ready(function () {

    if (!cookie.checkCookie()) {
        $('.cookie-container').toggleClass('open');
        cookie.setCookie();
    }

    $('.cookie-agree').click(function () {
        $('.cookie-container').toggleClass('open')
    });

    const testimonials = document.querySelector('.testimonials');
    const actualities = document.querySelector('.actualities');

    if (!!testimonials) {
        $('.testimonials').slick({
            accessibility: true,
            adaptiveHeight: true,
            autoplay: false,
            /*autoplaySpeed: 10000,*/
            arrows: true,
            draggable: true,
            dots: false,
            swipe: true,
            infinite: true,
            pauseOnHover: true,
            mobileFirst: true,

            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
            },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true,
                    }
            },
                {
                    breakpoint: 320,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
            }
        ]

        });
    }

    if (!!actualities) {
        $('.actualities').slick({
            accessibility: true,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 10000,
            arrows: true,
            draggable: true,
            dots: false,
            swipe: true,
            infinite: true,
            pauseOnHover: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }

});
